import { render } from "./EducationalQualification.vue?vue&type=template&id=40c37be8"
import script from "./EducationalQualification.vue?vue&type=script&lang=js"
export * from "./EducationalQualification.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__